import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Configurations from './appConfig';
import AppConfigUpdate from './appConfig-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}`} component={Configurations} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AppConfigUpdate} />
  </>
);

export default Routes;
